import { Fragment, useEffect, useState } from 'react';
import { Col, Card, Table, Input, Label, ModalFooter } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import { getUserDeviceChangeList, getUserList, isOpenStatusModal, statusToggle, updateDeviceChangeStatus } from '../../store/userSlice';
import CommonModal from '../../Components/Modals/modal';
import { Btn } from '../../AbstractElements';


const DeviceChangeListTable = () => {
  const storeVar = useSelector(state => state.user)
  const dispatch = useDispatch();
  const statusModalToggle = () => dispatch(statusToggle());
  const [stateStatus, setStateStatus] = useState('rejected');

  const [formVar, setFormVar] = useState({
    limit: 10,
    offset: 0,
    currentPage: 1,
    deviceChangeId: ""
  });

  useEffect(() => {
    dispatch(getUserDeviceChangeList(formVar.limit, formVar.offset))
  }, []);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(getUserList(formVar.limit, offset,))
  };

  const statusToggleModal = (data) => {
    dispatch(isOpenStatusModal(true))
    setStateStatus("rejected")
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      deviceChangeId: data._id,
    }))
  }

  const onValueChange = (event) => {
    setStateStatus(event.target.value)
  }

  const submitStatus = () => {
    dispatch(updateDeviceChangeStatus(formVar.deviceChangeId, stateStatus))
  }
  return (
    <Fragment>
      <Col sm='12'>
        <Card>

          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Name</th>
                  <th scope='col'>Email Id</th>
                  <th scope='col'>Phone Number</th>
                  <th scope='col'>DeviceId</th>
                  <th scope='col'>Device Name</th>
                  <th scope='col'>Status</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.deviceList?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td >{item.userId?.name}</td>
                    <td >{item.userId?.email}</td>
                    <td >{item.userId?.phoneNumber}</td>
                    <td >{item.deviceId}</td>
                    <td >{item.deviceName}</td>
                    <td>
                      {
                        item.status === 'approved' && <>
                          <span className={`font-success rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-check-circle-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>APPROVED</span>
                          </span>
                        </>
                      }
                      {
                        item.status === 'pending' && <>
                          <span className={`font-warning rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-clock-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>Pending</span>
                          </span>
                        </>
                      }
                      {
                        item.status === 'rejected' && <>
                          <span className={`font-danger w-50 rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-times-circle-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>REJECTED</span>
                          </span>
                        </>
                      }
                    </td>
                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div
                          className={`cursor-pointer bg-light-info font-info action-icon ${item.status !== 'pending' ? 'disabled' : ''}`}
                          onClick={(e) => {
                            if (item.status === 'pending') statusToggleModal(item);
                          }}
                        >
                          <i className="fa fa-toggle-on fa-lg"></i>
                          {item.status === 'pending' && (
                            <div className="tooltipCustom">Status Update</div>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.totalDeviceChange <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.totalDeviceChange > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.totalDeviceChange}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>

      <CommonModal isOpen={storeVar.isStatusOpenModal} title={'Status'} toggler={statusModalToggle} >
        <Col>
          <div className='d-flex m-15 m-checkbox-inline justify-content-center custom-radio-ml'>
            <div className='radio radio-primary'>
              <Input id='radioinline1' type='radio' className="radio_animated" name='radio1' checked={stateStatus === 'approved'} onChange={onValueChange} value='approved' />
              <Label className='mb-0' for='radioinline1'>
                <span className='digits'>APPROVE</span>
              </Label>
            </div>
            <div className='radio radio-primary'>
              <Input id='radioinline3' type='radio' className="radio_animated" name='radio3' checked={stateStatus === 'rejected'} onChange={onValueChange} value='rejected' />
              <Label className='mb-0' for='radioinline3'>
                <span className='digits'>REJECT</span>
              </Label>
            </div>
          </div>
        </Col>
        <ModalFooter className='justify-content-center'>
          <Btn attrBtn={{ color: 'secondary', onClick: statusModalToggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitStatus }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>

    </Fragment>
  );
};

export default DeviceChangeListTable;
